import { MaterialReactTable } from "material-react-table";
import { Card, CardBody, Row } from "reactstrap";
import { CustomerListRowOptions } from "./CustomerListRowOptions";
import { CustomerPreview } from "./CustomerPreview";
import Simulate from "./Simulate";
import React, { useEffect } from "react";

export const TableForAI = ({ getTable, searchColumns, searchData, orderPermission, customerPermission, navigate, dispatch, setRenderSimulate, setLoading, simulateOrPreview, index, setIndex, setActiveTab, fetchCustomerDetails, stationPermission, reservationPermission, getCustomerData, storeRow, setDefault, renderSimulate, pagination, customerData, activeTab, tabChange, setOpen, toggle, noCurrencyArray, currencyArray, fetchCustomerSummaryData, reservationDataArray, duration, subscriptionsArray, convertNumberOfDaysToMonthYear, formatDate, getDayDiff, current, errorMessage,errorIcon,TableShow,toggleModal,setMessageForPopUp,setCustomerId}) => {
    return (
        <CardBody>
            {!getTable ?
            
                null
                : <div className="container-fluid px-0" > <Card className="disable-margin-card w-100">
                    <CardBody>
                        <Row className="mb-3 mt-1 table-responsive">
                            <MaterialReactTable data={searchData} columns={searchColumns}
                                muiTableHeadCellProps={{
                                    sx: {
                                        fontFamily: "Inter,sans-serif",
                                    },
                                }}
                                muiTableBodyCellProps={{
                                    sx: {
                                        fontFamily: "Inter,sans-serif",
                                    },
                                }}
                                muiTableDetailPanelProps={{
                                    sx: {
                                        fontFamily: "Inter,sans-serif",
                                    },
                                }}
                                enablePagination={false}
                                enableGlobalFilter={true}
                                enableColumnOrdering={false}
                                enableColumnDragging={false}
                                enableDensityToggle={false}
                                enableColumnActions={true}
                                displayColumnDefOptions={{
                                    "mrt-row-actions": {
                                        header: "",
                                        enableHiding: true,
                                    },
                                }}
                                enableRowActions
                                initialState={{
                                    columnVisibility: {
                                        "mrt-row-expand": false,
                                    },
                                }}
                                renderRowActionMenuItems={({ closeMenu, row }) => (
                                    <CustomerListRowOptions orderPermission={orderPermission} customerPermission={customerPermission}
                                        navigate={navigate}
                                        row={row}
                                        closeMenu={closeMenu}
                                        dispatch={dispatch}
                                        setRenderSimulate={setRenderSimulate}
                                        setLoading={setLoading}
                                        simulateOrPreview={simulateOrPreview}
                                        index={index}
                                        setIndex={setIndex}
                                        setActiveTab={setActiveTab}
                                        fetchCustomerDetails={fetchCustomerDetails}
                                        stationPermission={stationPermission}
                                        reservationPermission={reservationPermission}
                                        getCustomerData={getCustomerData}
                                        storeRow={storeRow}
                                        setDefault={setDefault} 
                                        toggleModal ={toggleModal}
                                        setMessageForPopUp={setMessageForPopUp}
                                        setCustomerId={setCustomerId}
                                        />
                                )}
                                renderDetailPanel={({ row }) => (
                                    <React.Fragment>
                                        {useEffect(() => {
                                            row.toggleExpanded(false);
                                        }, [pagination])}
                                        {renderSimulate ? (
                                            <Simulate row={row} />
                                        ) : (
                                            <div className="preview-customer">
                                            <CustomerPreview
                                                customerData={customerData}
                                                row={row}
                                                activeTab={activeTab}
                                                setActiveTab={setActiveTab}
                                                tabChange={tabChange}
                                                open={open}
                                                setOpen={setOpen}
                                                toggle={toggle}
                                                noCurrencyArray={noCurrencyArray}
                                                currencyArray={currencyArray}
                                                fetchCustomerSummaryData={fetchCustomerSummaryData}
                                                reservationDataArray={reservationDataArray}
                                                duration={duration}
                                                subscriptionsArray={subscriptionsArray}
                                                convertNumberOfDaysToMonthYear={convertNumberOfDaysToMonthYear}
                                                formatDate={formatDate}
                                                getDayDiff={getDayDiff}
                                                current={current} />
                                                </div>
                                        )}
                                    </React.Fragment>
                                )}
                                
                            />
                        </Row>
                    </CardBody>
                </Card>
                </div>}
        </CardBody>
    )
}